import { defaultMappedRole } from '../../../config/schoolConfig';
import { AttendanceSource, StaffAttendanceView } from '../types';

export const transformAttendanceData = (
  attendanceData: StaffAttendanceView[]
) => {
  const sourceMapping: Record<AttendanceSource, string> = {
    [AttendanceSource.ADMIN]: 'ADMIN',
    [AttendanceSource.TRACKER]: 'DEVICE',
    [AttendanceSource.CRON]: 'SYSTEM',
    [AttendanceSource.SELF]: 'STAFF'
  };

  return attendanceData.map((record: StaffAttendanceView) => ({
    'Member Code': record.memberCode || '',
    Name: record.name,
    Role:
      record.displayRole ||
      defaultMappedRole[record.role as unknown as string] ||
      record.role ||
      '',
    Email: record.email,
    Status: record.markedAs,
    School: record.school,
    'Attendnace Date': record.attendanceDate,
    'Marked By': record.source ? sourceMapping[record.source] : '',
    Shift:
      record.shiftDetails?.startTime && record.shiftDetails?.endTime
        ? `${record.shiftDetails?.startTime} - ${record.shiftDetails?.endTime}`
        : '',
    'Punch In Time': record.punchInTime || '',
    'Punch Out Time': record.punchOutTime || '',
    'Marked As Late':
      record.markedAsLate === true
        ? 'YES'
        : record.markedAsLate === false
          ? 'NO'
          : '',
    Remarks: record.remarks
  }));
};
